import { render, staticRenderFns } from "./DeleteReaderModal.vue?vue&type=template&id=22c0bbb2&"
import script from "./DeleteReaderModal.vue?vue&type=script&lang=js&"
export * from "./DeleteReaderModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteReaderModal.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports